import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["indicator", "announcement"];
  static classes = ["indicatorActive", "indicatorInactive"];
  static values = { autoHideDelay: { type: Number, default: 0 }, message: String };

  showIndicator() {
    this.indicatorTarget.classList.add(...this.indicatorActiveClasses);
    this.indicatorTarget.classList.remove(...this.indicatorInactiveClasses);
    this.announce(this.messageValue);

    if (this.autoHideDelayValue > 0) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = setTimeout(() => this.hideIndicator(), this.autoHideDelayValue);
    }
  }

  hideIndicator() {
    this.indicatorTarget.classList.add(...this.indicatorInactiveClasses);
    this.indicatorTarget.classList.remove(...this.indicatorActiveClasses);
    this.announce("");
  }

  announce(message) {
    if (this.hasAnnouncementTarget) {
      this.announcementTarget.textContent = message;
    }
  }

  disconnect() {
    clearTimeout(this.hideTimeout);
  }
}
